import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Icon } from './Icon'
import { useUI } from '../store/ui'
import { useSession } from '../store/session'
import { NAV } from '../shell/nav'
import { matchPermission } from '../rbac/permissions'

export function CommandPalette() {
  const { cmdkOpen, cmdkQuery, setCmdk, setCmdkQuery } = useUI()
  const me = useSession((s) => s.me)
  const nav = useNavigate()
  const perms = me?.permissions ?? []

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setCmdk(!cmdkOpen)
      }
      if (e.key === 'Escape') setCmdk(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [cmdkOpen, setCmdk])

  const items = useMemo(
    () =>
      NAV.flatMap((g) => g.items)
        .filter((it) => matchPermission(perms, it.perm))
        .filter((it) => it.label.toLowerCase().includes(cmdkQuery.toLowerCase())),
    [perms, cmdkQuery],
  )

  if (!cmdkOpen) return null
  return (
    <div className="cmdk-wrap" onClick={() => setCmdk(false)}>
      <div className="cmdk" onClick={(e) => e.stopPropagation()}>
        <input autoFocus placeholder="Jump to a screen…" value={cmdkQuery} onChange={(e) => setCmdkQuery(e.target.value)} />
        <div className="cmdk-list">
          <div className="cmdk-group-label">Screens</div>
          {items.map((it) => (
            <button
              key={it.to}
              className="cmdk-item"
              onClick={() => {
                nav(it.to)
                setCmdk(false)
              }}
            >
              <span className="ib">
                <Icon name={it.icon} size={16} />
              </span>
              {it.label}
              <span className="chev">
                <Icon name="chevR" size={14} />
              </span>
            </button>
          ))}
          {items.length === 0 && <div className="cmdk-item">No matches</div>}
        </div>
      </div>
    </div>
  )
}
